import {createEntityService} from 'utils/createEntityService';
import {BackgroundDocument} from 'types/backgroundDocument';

export const BackgroundDocumentService =
  createEntityService<BackgroundDocument>({
    baseUrl: 'api/v1/background_documents',
    entityName: 'backgroundDocument',
  });
